import { render, staticRenderFns } from "./QuickReplyButtons.vue?vue&type=template&id=2aca9bfa&scoped=true"
import script from "./QuickReplyButtons.vue?vue&type=script&lang=js"
export * from "./QuickReplyButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca9bfa",
  null
  
)

export default component.exports